const ActionTypes = {
  FETCH_HOUSES: 'FETCH_HOUSES',
  RECEIVE_HOUSES: 'RECEIVE_HOUSES',
  SHOW_HOUSE: 'SHOW_HOUSE',
  REMOVE_SHOW_HOUSE: 'REMOVE_SHOW_HOUSE',
  ADD_HOUSE: 'ADD_HOUSE',
  DELETE_HOUSE: 'DELETE_HOUSE',
};

export default ActionTypes;
